const ADD_EVENTS = 'tuko-kalenteri/events/ADD_EVENTS';
const SELECT_EVENT = 'tuko-kalenteri/events/SELECT_EVENT';

export default function events(state = { allEvents: [], selectedEvent: undefined }, action) {
  switch (action.type) {
    case ADD_EVENTS:
      return Object.assign({}, state, { allEvents: action.events });
    case SELECT_EVENT:
      return Object.assign({}, state, { selectedEvent: (action.eventId !== '') ? action.eventId : undefined });
    default:
      return state;
  }
}

export function addEvents(eventList) {
  return { type: ADD_EVENTS, events: eventList };
}

export function selectEvent(eventId) {
  return { type: SELECT_EVENT, eventId };
}



// WEBPACK FOOTER //
// ./src/reducers/events.js